export default (() => {

    function sortDescending(attribute, a, b) {

        if (a[attribute] < b[attribute]) {

            return 1;

        } else if (a[attribute] > b[attribute]) {

            return -1;

        } else {

            return 0;
        }
    }

    function sortAscending(attribute, a, b) {

        if (a[attribute] < b[attribute]) {

            return -1;

        } else if (a[attribute] > b[attribute]) {

            return 1;

        } else {

            return 0;
        }
    }

    return {
        sortDescending,
        sortAscending
    };

})();


// WEBPACK FOOTER //
// ./services/sorter.js